// extracted by mini-css-extract-plugin
export default {"captcha":"z8YQMGjqxj6t0v5pFQju"};